import formatter from "../../utils/formatter";
import CurrencyInput from "../CurrencyInput/CurrencyInput";

class PercentageInput extends CurrencyInput {
    toFormat = (value) => {
        if (!value) return undefined;
        const formattedValue = formatter({ value, fieldSuffix: 'PercentWDecimal' });
        return formattedValue;
    }
}

export default PercentageInput;